import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Zoomit = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
      fill={fill}
    >
      <defs>
        <clipPath>
          <path d="M4.213 16H0l4.776-6.243L7.734 5.89h3.609l-5.079 6.6h12.84L16.424 16zm9.907-5.89h-3.027l5.079-6.6H3.332L6.012 0h16.424l-4.775 6.243L14.7 10.11z" />
        </clipPath>
      </defs>
      <g transform="translate(-125 -11)">
        <g transform="translate(126 15)">
          <path d="M4.213 16H0l4.776-6.243L7.734 5.89h3.609l-5.079 6.6h12.84L16.424 16zm9.907-5.89h-3.027l5.079-6.6H3.332L6.012 0h16.424l-4.775 6.243L14.7 10.11z" />
        </g>
      </g>
    </svg>
  );
};

Zoomit.displayName = 'Zoomit';
